export const searchEventInitialState = {
  filters: {
    name: "",
    address: "",
    country: "",
    categories: "",
    searchings: "",
    interests: "",
    dates: "",
    categoryNames: "",
    searchingNames: "",
    interestNames: "",
    rating: "",
  },
  currentPage: 1,
  totalPages: 1,
  eventList: [],
  isEventListLoading: false,
};

export const searchEventReducer = (state, action) => {
  switch (action.type) {
    case "SET_EVENT_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        currentPage: 1, // reset to page 1 when filters change
      };
    case "SET_EVENT_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_EVENT_DATA":
      return {
        ...state,
        eventList: action.payload.data,
        totalPages: action.payload.totalPages,
        isEventListLoading: false,
      };
    case "SET_EVENT_LOADING":
      return { ...state, isEventListLoading: action.payload };
    case "RESET_EVENT_FILTERS":
      return {
        ...searchEventInitialState,
      };
    default:
      return state;
  }
};
